import { FC } from 'react';

const getLabelName = (filterType: string) => {
    switch (filterType) {
        case 'reg':
            return 'Дата регистрации';
        case 'geo':
            return 'Дата рекламы';
        case 'app':
            return 'Дата рекламы';
        case 'order':
            return 'Дата заказа';
        case 'payment':
            return 'Дата платежа';
        case 'web':
            return 'Дата вебинара';
        case 'ad':
            return 'Дата рекламы';
        default:
            return '';
    }
};

const ChartLabel: FC<any> = ({ chartFilter, isDisabled = false }) => {

    return chartFilter && !isDisabled ? (
        <div className="universal-chart-label" style={{ width: '100%' }}>
            <p>
                {getLabelName(chartFilter)}
            </p>
        </div>
    ) : null;
};

export default ChartLabel;
